import { getValidationResolver, useForm } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import * as yup from 'yup';

import { DEFAULT_DATE_FORMAT, REQUIRED_TEXT } from '@/common/constants';
import { isDateInFuture } from '@/utils';

import { AuthorizedUser } from '../../../authorizedUsers.types';

export enum FormFields {
  firstName = 'firstName',
  lastName = 'lastName',
  relationshipType = 'relationshipType',
  birthOn = 'birthOn',
}

export interface AuthorizedUserFormValues {
  [FormFields.firstName]: string;
  [FormFields.lastName]: string;
  [FormFields.relationshipType]: string;
  [FormFields.birthOn]: string;
}

interface Props {
  defaultValue?: AuthorizedUser | null;
}

const useAuthorizedUserForm = ({ defaultValue }: Props) => {
  const methods = useForm<AuthorizedUserFormValues>({
    defaultValues: {
      [FormFields.firstName]: defaultValue?.firstName || '',
      [FormFields.lastName]: defaultValue?.lastName || '',
      [FormFields.relationshipType]: defaultValue?.relationshipType || '',
      [FormFields.birthOn]: defaultValue?.birthOn
        ? dayjs(defaultValue.birthOn).format(DEFAULT_DATE_FORMAT)
        : '',
    },
    resolver: getValidationResolver<AuthorizedUserFormValues>({
      [FormFields.firstName]: yup.string().required(REQUIRED_TEXT),
      [FormFields.lastName]: yup.string().required(REQUIRED_TEXT),
      [FormFields.relationshipType]: yup.string().required(REQUIRED_TEXT),
      [FormFields.birthOn]: yup
        .string()
        .required(REQUIRED_TEXT)
        .test('date', 'Date cannot be in the future', (date) => !isDateInFuture(date)),
    }),
  });

  return { methods };
};

export default useAuthorizedUserForm;
